// extracted by mini-css-extract-plugin
export var modal = "_ba-0";